import React from 'react'
import { useLocation } from 'react-router-dom'

// We can get rid of this when we migrate to React Router 6 as they have hook for search params
function useQuery() {
    const { search } = useLocation()
    return React.useMemo(() => new URLSearchParams(search), [search])
}

export default useQuery
